import React from 'react';
import { DeleteOutlineOutlined } from '@material-ui/icons';
import { Checkbox, Link, TableCell, TableRow } from '@material-ui/core';
import { formatDateMDYWithoutTimeZone, toTitleCase } from '../../../../helpers/utils';

const UnifiedTeamMemberRow = ({
  member,
  type, // 'active' | 'former' | 'potential'
  index,
  selected = [],
  onSelect,
  onOpenContact,
  onPrimaryAction,
  onSecondaryAction,
}) => {
  const isActive = type === 'active';
  const isFormer = type === 'former';
  const isPotential = type === 'potential';

  const hasCheckbox = isActive || isFormer;
  const isChecked = hasCheckbox && selected.indexOf(member.id) !== -1;

  const handleCheckboxChange = (event) => {
    if (onSelect) {
      const crdId = isActive
        ? member.ria_contact_crd_id
        : isFormer
          ? member.ria_contact_crd_id
          : null;
      onSelect(event, member.id, crdId);
    }
  };

  const firstName = isPotential
    ? toTitleCase(member.contact_first_name)
    : member.first_name;

  const lastName = isPotential
    ? toTitleCase(member.contact_last_name)
    : member.last_name;

  const crdId = isPotential
    ? member.contact_crd_id
    : member.ria_contact_crd_id;

  const handleOpenContact = () => {
    if (onOpenContact) {
      onOpenContact(crdId, index);
    }
  };

  return (
    <TableRow hover>
      {hasCheckbox && (
        <TableCell className='grid-table-cell' padding='checkbox'>
          <Checkbox
            checked={isChecked}
            color='primary'
            onChange={handleCheckboxChange}
            value={member.id}
          />
        </TableCell>
      )}

      {isFormer && <TableCell>{crdId}</TableCell>}

      <TableCell>
        {(isActive || isPotential) ? (
          <Link onClick={handleOpenContact}>{firstName}</Link>
        ) : (
          firstName
        )}
      </TableCell>

      <TableCell>
        {(isActive || isPotential) ? (
          <Link onClick={handleOpenContact}>{lastName}</Link>
        ) : (
          lastName
        )}
      </TableCell>

      {!isFormer && <TableCell>{crdId}</TableCell>}

      {!isPotential && (
        <TableCell>{member.ria_contact_current_company}</TableCell>
      )}

      {isFormer && (
        <>
          <TableCell>{member.active === true ? 'Yes' : 'No'}</TableCell>
          <TableCell>
            {member.end_date ? formatDateMDYWithoutTimeZone(member.end_date) : ''}
          </TableCell>
          <TableCell>
            <span
              className='material-icons MuiIcon-root icon trash'
              onClick={() => onSecondaryAction && onSecondaryAction(member.id)}
            >
              <DeleteOutlineOutlined />
            </span>
          </TableCell>
        </>
      )}

      <TableCell>
        {isActive && (
          <Link onClick={() => onPrimaryAction && onPrimaryAction(member.id)}>
            Mark as former team member
          </Link>
        )}
        {isFormer && (
          <Link onClick={() => onPrimaryAction && onPrimaryAction(member.id)}>
            Mark as active team member
          </Link>
        )}
        {isPotential && (
          <Link onClick={() => onPrimaryAction && onPrimaryAction(member.id)}>
            Add to Team
          </Link>
        )}
      </TableCell>
    </TableRow>
  );
};

export default UnifiedTeamMemberRow;
